import React from "react";
import {
    Card,
    CardContent,
    CardActions,
    Skeleton,
} from "@mui/material";

/**
 * StrategyCardSkeleton Component
 * Loading placeholder for StrategyCard - matches the same layout/dimensions
 */
const StrategyCardSkeleton = () => {
    return (
        <Card sx={{
            width: "100%",
            height: "100%",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
        }}>
            {/* Image placeholder */}
            <Skeleton
                variant="rectangular"
                height={180}
                animation="wave"
                sx={{ bgcolor: "action.hover" }}
            />

            <CardContent>
                {/* Title placeholder */}
                <Skeleton
                    variant="text"
                    width="70%"
                    height={32}
                    animation="wave"
                    sx={{ mb: 1 }}
                />
                {/* Description placeholders */}
                <Skeleton variant="text" width="100%" animation="wave" />
                <Skeleton variant="text" width="40%" animation="wave" />
                <Skeleton variant="text" width="55%" animation="wave" />
            </CardContent>

            <CardActions sx={{ width: "100%", marginTop: "auto" }}>
                {/* Button placeholder */}
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={36}
                    animation="wave"
                    sx={{ borderRadius: 1 }}
                />
            </CardActions>
        </Card>
    );
};

export default StrategyCardSkeleton;
